import { AuthProvider } from "@/context/auth-context";
import { useLoaderData } from "@tanstack/react-router";
import { ReactNode } from "react";

interface SignUpAuthWrapperProps {
	children: ReactNode;
}

const SignUpAuthWrapper = ({ children }: SignUpAuthWrapperProps) => {
	const data = useLoaderData({ from: "/sign_up" });

	const value = {
		user: data,
	};

	return <AuthProvider value={value}>{children}</AuthProvider>;
};

export default SignUpAuthWrapper;
